<template>
  <div class="inline-flex items-center gap-1 p-1 rounded-full bg-white/10 border border-white/15"
    role="group" :aria-label="$t('theme_label')" :title="$t('theme_label')">
    <button v-for="opt in options" :key="opt.id" type="button"
      @click="setTheme(opt.id)"
      :aria-pressed="theme === opt.id"
      :title="$t(opt.labelKey)"
      :aria-label="$t(opt.labelKey)"
      class="w-6 h-6 rounded-full flex items-center justify-center transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-[var(--color-accent-bright)]"
      :class="theme === opt.id ? 'ring-2 ring-offset-1 ring-white' : 'opacity-70 hover:opacity-100'">
      <span class="w-3.5 h-3.5 rounded-full block" :style="{ backgroundColor: opt.dot }"></span>
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue'

// The two swatch dots are ALWAYS these literal colors — they identify the
// themes and are themselves never themed.
const options = [
  { id: 'blue', labelKey: 'theme_blue', dot: 'var(--swatch-blue)' },
  { id: 'gold', labelKey: 'theme_gold', dot: 'var(--swatch-gold)' }
]

function readTheme() {
  return document.documentElement.dataset.theme === 'gold' ? 'gold' : 'blue'
}

const theme = ref(readTheme())

const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches

function setTheme(id) {
  if (id === theme.value) return
  const root = document.documentElement

  // Animate the switch, but only briefly, so we never leave every element
  // permanently transitioning. Skipped when the user prefers reduced motion.
  const animate = !prefersReducedMotion()
  if (animate) root.classList.add('theme-anim')

  if (id === 'gold') root.dataset.theme = 'gold'
  else delete root.dataset.theme
  localStorage.setItem('xs-theme', id)
  theme.value = id

  if (animate) {
    window.setTimeout(() => root.classList.remove('theme-anim'), 450)
  }
}
</script>
